import "./Noopeningspage.css";
import Header from "./Header";
import Footer from "./Footer";
import React, { useState, useEffect } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate } from "react-router-dom";
import "./Datatable.css";
import Swal from "sweetalert2";
import "font-awesome/css/font-awesome.min.css";
import ReactPaginate from "react-paginate";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function Noopenings() {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.currenopening;

  const [form2Events, setForm2Events] = useState([]);
  const [alert, setAlert] = useState(null);
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 5;

  const fetchData = async (page) => {
    try {
      const response = await axios.get(
        `${CONFIG.BASE_URL}/career/get/all?page=${
          page + 1
        }&limit=5&search=${searchItem}`
      );
      setForm2Events(response.data.jobs);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, searchItem]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const paginatedData = form2Events.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div>
      <SEO {...meta} />

      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
    <!-- Header Start --> */}
      <div class="container-fluid Noopenings bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Current Opening
          </h4>
        </div>
      </div>
      {/* <!-- Header End -->

    <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                className="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div className="modal-body align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i className="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      {/* <!-- About Start --> */}
      <div className="container-fluid innercontain terms no_job_wrap overflow-hidden desktop_pt  py-5">
        <div className="container mob_pt">
          <div
            class="text-left job_search_sec d-flex mx-auto wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="col-8 p-4">
              <h1 className="display-3 text-white mb-3">
                Start doing work matters
              </h1>
              <p className="">
                our philosophy is very simple - hire a team devisers, passionate
                people and foster a cultural empowers you to do your best work.
              </p>
            </div>
            <div className="col-4 jobs_searching p-4 ms-auto">
              <div className="position-relative">
                <input
                  class="form-control rounded-pill w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Jobs search"
                  onChange={(e) => setSearchItem(e?.target?.value)}
                />
              </div>
            </div>
          </div>

          {form2Events.map((item) => (
            <div className="company_openings">
              <div className="row gx-0 gy-4 ">
                <div
                  class="col-lg-6 career_jobinteam col-xl-4"
                  data-wow-delay="0.3s"
                >
                  {/*left side content*/}

                  <div className="p-2">
                    <h3 className="text-white h6">{item.department}</h3>
                    <p className="mb-0 p-0 text-white">
                      {item.departmentNotes}
                    </p>
                  </div>
                  <div className="service-content">
                    <label className="text-white p-2  mt-2">Benefits:</label>
                    <p class="mb-0 p-2 text-white">{item.benefits}</p>
                  </div>
                </div>
                <div
                  className="col-lg-6 col-xl-8 wow fadeInRight"
                  data-wow-delay="0.2s"
                >
                  <div className="service-item career_details rounded p-4 pt-1 pb-1 mb-3">
                    <div class="row">
                      <div className="col-12 p-2  border-0">
                        <div className="d-flex job_destial_tiles1">
                          {/*right side content */}

                          <div className="service-content">
                            <p className="mb-0 p-2 ps-0">{item.jobTitle}</p>
                          </div>
                          <div className="service-content d-flex">
                            <i className="fas fa-map-marker-alt fa-1x p-2 mx-auto"></i>
                            <p className="mb-0 p-2">{item.location}</p>

                            {/* <p className="mb-0 p-2">Design</p> */}
                          </div>
                          <div className="service-content d-flex">
                            <i className="fas fa-building fa-1x p-2 mx-auto"></i>
                            <p className="mb-0 p-2">{item.companyName}</p>
                          </div>
                          <div className="service-content d-flex">
                            <i className="fas fa-life-bouy fa-1x p-2 mx-auto"></i>
                            <p className="mb-0 p-2">{item.jobType}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 p-0  border-0">
                        <div className="d-flex">
                          <div className="service-content">
                            <p class="mb-0 p-2">{item.jobDescription}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 p-2 pb-3 border-0">
                        <div className="d-flex job_destial_tiles2">
                          <div className="col-7 p-0 d-flex border-0">
                            <div className="service-content d-flex">
                              <i className="fas fa-clock fa-1x p-2 ps-0 text-white p-2"></i>
                              <p className="mb-0 p-2 ">{item.shiftTime}</p>
                            </div>
                            <div className="service-content d-flex">
                              <i className="fas fa-hourglass-half fa-1x p-2 text-white mx-auto"></i>
                              <p className="mb-0 p-2">{item.experience}</p>
                            </div>
                            <div className="service-content d-flex">
                              <i className="fas fa-money fa-1x p-2 text-white mx-auto"></i>
                              <p className="mb-0 p-2">{item.salary}</p>
                            </div>
                            <div className="service-content d-flex">
                              <i className="fas fa-users fa-1x p-2 text-white mx-auto"></i>
                              <p className="mb-0 p-2">{item.vacancy}</p>
                            </div>
                          </div>
                          <div className="col-5 p-0 career_apply  border-0">
                            <div className="service-content d-flex">
                              <a href="/upload-cv">
                                <button className="btn  btn-secondary m-auto rounded-pill ">
                                  Apply
                                </button>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active-pagnation"}
            pageLinkClassName={"pagenation-style"}
          />
        </div>
      </div>
      {/* <!-- About End --> */}

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Noopenings;
